import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, TButton } from '@/shared/ui/lib/Button';
import { SvgIcon } from '@/shared/ui/SvgIcon';

import { CreateCompanyDialog } from './CreateCompanyDialog';

export type TCreateCompanyButton = TButton & {
  onCreated?: () => void;
};

export const CreateCompanyButton = ({
  onCreated,
  ...otherProps
}: TCreateCompanyButton) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        startIcon={<SvgIcon name="add" />}
        size="large"
        {...otherProps}
      >
        {t('company:buttons.create')}
      </Button>
      <CreateCompanyDialog
        open={open}
        onClose={handleClose}
        onCreated={onCreated}
      />
    </>
  );
};
